import React from 'react';
import type File from '../../../interfaces/File';

import useFormatTimestamp from '../../../hooks/useFormatTimestamp';
import { dateFromTicks } from '../../../utils/utils';

interface FilesTableLastModifiedCellProps {
  file: File;
}

const FilesTableLastModifiedCell: React.FC<FilesTableLastModifiedCellProps> = ({ file }) => {
  const formatTimestamp = useFormatTimestamp();

  return <span>{formatTimestamp(dateFromTicks(file.lastModifiedAt)) || '-'}</span>;
};

export default FilesTableLastModifiedCell;
